export default __webpack_public_path__ + "static/media/The Heart of Atlantis.d3736df9.jpg";